(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));
      this.prevBtn = this.querySelector('.hero-slider__arrow--prev');
      this.nextBtn = this.querySelector('.hero-slider__arrow--next');
      this.viewport = this.querySelector('.hero-slider__viewport');
      this.currentIndex = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.timer = null;
      this.touchStartX = 0;
      this.touchEndX = 0;
    }

    connectedCallback() {
      if (this.slides.length < 2) return;

      this.prevBtn?.addEventListener('click', () => this.go(this.currentIndex - 1, true));
      this.nextBtn?.addEventListener('click', () => this.go(this.currentIndex + 1, true));
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.go(i, true));
      });

      this.viewport.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.currentIndex - 1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.currentIndex + 1, true); }
      });

      this.viewport.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      this.viewport.addEventListener('touchend', (e) => {
        this.touchEndX = e.changedTouches[0].screenX;
        const dx = this.touchEndX - this.touchStartX;
        if (Math.abs(dx) > 50) this.go(this.currentIndex + (dx < 0 ? 1 : -1), true);
      }, { passive: true });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.play());

      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.autoplay && !prefersReduced) this.play();
    }

    disconnectedCallback() {
      this.pause();
    }

    go(index, userInitiated = false) {
      const total = this.slides.length;
      const next = ((index % total) + total) % total;
      if (next === this.currentIndex) return;

      this.slides[this.currentIndex].removeAttribute('data-active');
      this.dots[this.currentIndex]?.setAttribute('aria-selected', 'false');

      this.slides[next].setAttribute('data-active', 'true');
      this.dots[next]?.setAttribute('aria-selected', 'true');

      this.currentIndex = next;

      if (userInitiated && this.autoplay) {
        this.pause();
        this.play();
      }
    }

    play() {
      if (!this.autoplay || this.timer) return;
      this.timer = window.setInterval(() => this.go(this.currentIndex + 1), this.interval);
    }

    pause() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }
  }

  customElements.define('hero-slider', HeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-split"] && !Shopify.designMode) return;
  try {
    
  class HeroSplit extends HTMLElement {
    constructor() {
      super();
      this.slides   = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots     = Array.from(this.querySelectorAll('[data-dot]'));
      this.live     = this.querySelector('[data-live]');
      this.prev     = this.querySelector('[data-prev]');
      this.next     = this.querySelector('[data-next]');
      this.counter  = this.querySelector('[data-counter]');
      this.idx      = 0;
      this.total    = this.slides.length;
      this.duration = parseInt(this.dataset.duration, 10) || 6000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.timer    = null;
      this.visible  = true;
      this.io       = null;
      this.reduced  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onVis    = this.onVis.bind(this);
    }

    connectedCallback() {
      if (!this.total) return;
      this.prev?.addEventListener('click', () => this.go(this.idx - 1));
      this.next?.addEventListener('click', () => this.go(this.idx + 1));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
      this.addEventListener('keydown', (e) => this.handleKey(e));
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.play());
      document.addEventListener('visibilitychange', this.onVis);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.play(); else this.pause();
        }, { threshold: 0.25 });
        this.io.observe(this);
      }
      this.applyTabIndex();
      this.play();
    }

    disconnectedCallback() {
      this.pause();
      this.io?.disconnect();
      document.removeEventListener('visibilitychange', this.onVis);
    }

    onVis() {
      if (document.hidden) this.pause(); else this.play();
    }

    applyTabIndex() {
      this.slides.forEach((s, i) => {
        const on = i === this.idx;
        s.querySelectorAll('a, button').forEach((el) => { el.tabIndex = on ? 0 : -1; });
      });
    }

    go(n) {
      const total = this.total;
      this.idx = ((n % total) + total) % total;
      this.slides.forEach((s, i) => {
        const on = i === this.idx;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      this.dots.forEach((d, i) => {
        const on = i === this.idx;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
        d.tabIndex = on ? 0 : -1;
        // Force CSS animation restart by reflowing the fill node
        const fill = d.querySelector('.hero-split__bar-fill');
        if (fill) {
          fill.style.animation = 'none';
          /* eslint-disable-next-line no-unused-expressions */
          fill.offsetHeight;
          fill.style.animation = '';
        }
      });
      if (this.counter) this.counter.textContent = String(this.idx + 1).padStart(2, '0');
      if (this.live) this.live.textContent = `Diapositiva ${this.idx + 1} de ${total}`;
      this.applyTabIndex();
      this.restart();
    }

    handleKey(e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); this.go(this.idx - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.idx + 1); }
    }

    play() {
      if (!this.autoplay || this.reduced || this.timer || !this.visible || document.hidden) return;
      this.removeAttribute('data-paused');
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.go(this.idx + 1);
      }, this.duration);
    }

    pause() {
      if (this.timer) { clearTimeout(this.timer); this.timer = null; }
      this.setAttribute('data-paused', 'true');
    }

    restart() { this.pause(); this.play(); }
  }

  if (!customElements.get('hero-split')) {
    customElements.define('hero-split', HeroSplit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-estimator"] && !Shopify.designMode) return;
  try {
    
  class ShippingEstimator extends HTMLElement {
    constructor() {
      super();
      this.select = this.querySelector('.shipping-estimator__select');
      this.result = this.querySelector('.shipping-estimator__result');
    }

    connectedCallback() {
      if (!this.select || !this.result) return;
      this.select.addEventListener('change', () => this.update());
    }

    update() {
      const opt = this.select.options[this.select.selectedIndex];
      if (!opt || !opt.value) {
        this.result.removeAttribute('data-has-result');
        this.result.innerHTML = '<span class="shipping-estimator__result-placeholder">Ingresa tu región para ver el tiempo estimado.</span>';
        return;
      }

      const min = parseInt(opt.dataset.min, 10);
      const max = parseInt(opt.dataset.max, 10);
      let text = '';

      if (min === 0 && max === 0) {
        text = '<span class="shipping-estimator__result-highlight">A cotizar</span><span>Escríbenos por WhatsApp para envío a esta zona.</span>';
      } else if (min === max) {
        text = `<div><span class="shipping-estimator__result-highlight">${min} ${min === 1 ? 'día hábil' : 'días hábiles'}</span><span>desde el despacho</span></div>`;
      } else {
        text = `<div><span class="shipping-estimator__result-highlight">${min} – ${max} días hábiles</span><span>desde el despacho</span></div>`;
      }

      this.result.setAttribute('data-has-result', 'true');
      this.result.innerHTML = text;
    }
  }

  customElements.define('shipping-estimator', ShippingEstimator);

  } catch(e) { console.error(e); }
})();
})();
